import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";

export default function Login() {
  return (
    <div className="App min-h-screen">
      <Header variant="landing" />
      <main className="max-w-md mx-auto px-6 py-24 text-center">
        <div className="flex justify-center mb-6">
          <img src={`${process.env.PUBLIC_URL || ""}/mentogram-logo-dark.png`} alt="Mentogram"
            className="h-14 w-auto select-none" draggable="false" data-testid="login-logo" />
        </div>
        <h1 className="font-display text-3xl font-extrabold text-slate-900 tracking-tight">Welcome back</h1>
        <p className="mt-3 text-slate-700 text-sm">
          Returning applicant sign-in continues your saved learner profile. This will be enabled with your
          admissions account.
        </p>
        <Link to="/" data-testid="login-back"
          className="btn-orange inline-block mt-8 rounded-full px-6 py-2.5 text-sm font-semibold">
          Talk to Mentis instead
        </Link>
      </main>
    </div>
  );
}
